// noinspection JSIgnoredPromiseFromCall

import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { postDeviceTestConfiguration } from '../../services/DeviceService';
import { DeviceTestConfiguration, DeviceTestConfigurationPost } from '../../types/Devices';

type Result = UseMutationResult<DeviceTestConfiguration, Error, DeviceTestConfigurationPost>;

function usePostDeviceTestConfiguration(
  successCb: (result: DeviceTestConfiguration) => void,
  failureCb: (error: string) => void,
): Result {
  const queryClient = useQueryClient();

  return useMutation(postDeviceTestConfiguration, {
    onSuccess: (result) => {
      successCb(result);
      queryClient.invalidateQueries({ queryKey: ['device-test-configuration'] });
      // Toggling rewrites the activation speed keys on the device config itself.
      queryClient.invalidateQueries({ queryKey: ['device-configuration'] });
    },
    onError: (error: Error) => {
      failureCb(error.message);
    },
  });
}

export default usePostDeviceTestConfiguration;
